import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status"]
  static values = {
    delay: { type: Number, default: 600 }
  }

  connect() {
    this.pending = false
    this.submitting = false
  }

  disconnect() {
    this.clearTimer()
  }

  queue(event) {
    this.rememberFocus(event.currentTarget)
    this.clearTimer()
    this.timer = setTimeout(() => this.save(), this.delayValue)
  }

  save(event) {
    const focusedElement = this.element.contains(document.activeElement) ? document.activeElement : event?.currentTarget
    if (focusedElement) this.rememberFocus(focusedElement)
    this.clearTimer()

    if (this.submitting) {
      this.pending = true
      return
    }

    this.element.requestSubmit()
  }

  submitStart() {
    this.submitting = true
    if (this.element.contains(document.activeElement)) this.rememberFocus(document.activeElement)
    this.setStatus("Saving...", "saving")
  }

  submitEnd(event) {
    this.submitting = false
    this.setStatus(event.detail.success ? "Saved" : "Not saved", event.detail.success ? "saved" : "error")
    this.restoreFocus()

    if (this.pending) {
      this.pending = false
      this.save()
    }
  }

  clearTimer() {
    if (!this.timer) return

    clearTimeout(this.timer)
    this.timer = null
  }

  setStatus(message, state) {
    if (!this.hasStatusTarget) return

    this.statusTarget.textContent = message
    this.statusTarget.dataset.state = state
  }

  rememberFocus(element) {
    if (element?.id) this.focusedElementId = element.id
  }

  restoreFocus() {
    if (!this.focusedElementId) return

    const element = document.getElementById(this.focusedElementId)
    if (element && this.element.contains(element)) element.focus()
    this.focusedElementId = null
  }
}
